import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  appointmentId: yup.number().required(),
});

export function useReleaseAppointmentHoldMutation(options = {}) {
  const queryClient = useQueryClient();

  return useMutation(
    (payload) => {
      const req = requestSchema.validateSync(payload, { strict: true });

      return http.post(
        HTTP_ENDPOINTS.appointments.releaseHold(req.appointmentId),
      );
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.appointments.appointment],
        });
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.appointments.paymentLink],
        });
        options.onSuccess?.(...args);
      },
    },
  );
}
